import React from "react";
import { NavLink } from "react-router-dom";

export default function NavigationBar() {
  return (
    <header className="nav-container">
      <nav className="nav-item site-name">
        <NavLink to="/" exact>
          ZELIN
        </NavLink>
      </nav>

      <nav className="nav-item">
        <NavLink to="/projects">Projects</NavLink>
      </nav>

      <nav className="nav-item">
        <NavLink to="/about">About</NavLink>
      </nav>

      <nav className="nav-item">
        <NavLink to="/contact">Contact</NavLink>
      </nav>

      <nav className="nav-item">
        <NavLink to="/blog">Blog</NavLink>
      </nav>
    </header>
  );
}
